import { Component, OnInit, inject } from "@angular/core";
import { ViewService } from "core/view.service";
import { BaseComponent } from "process/view/base.component";
import { ComponentService } from "process/view/component.service";
import { Observable } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { FeedbackWidgetComponent } from "./feedback-widget.component";
import { FeedbackLinkWidgetComponent } from "./feedback-link-widget.component";

type ProcessView = stages.process.ProcessView;

@Component({
	selector: "stages-feedback-switch-widget",
	templateUrl: "./feedback-switch-widget.component.html",
	imports: [FeedbackWidgetComponent, FeedbackLinkWidgetComponent, AsyncPipe],
})
export class FeedbackSwitchWidgetComponent extends BaseComponent implements OnInit {
	private viewService = inject(ViewService);

	processView$!: Observable<ProcessView>;

	constructor() {
		const componentService = inject(ComponentService);

		super(componentService);
	}

	ngOnInit(): void {
		this.processView$ = this.viewService.awaitSelfElementObservable();
	}
}
